import { Button } from "@openanalyst-ai/ui/button"
import { useDialog } from "@openanalyst-ai/ui/context/dialog"
import { Dialog } from "@openanalyst-ai/ui/dialog"
import { IconButton } from "@openanalyst-ai/ui/icon-button"
import { Mark } from "@openanalyst-ai/ui/logo"
import { usePlatform } from "@/context/platform"

const WELCOME_SOURCES = [
  { label: "Workspace files", detail: "Docs, notes, recent changes" },
  { label: "10X account context", detail: "Companies, contacts, campaign signals" },
  { label: "Chat starts smarter", detail: "A brief is attached before you ask" },
]

export function AppStartupWelcomeDialog(props: { name: string }) {
  const dialog = useDialog()
  const platform = usePlatform()
  const openTenX = () => {
    platform.openLink("https://app.openanalyst.com")
    dialog.close()
  }

  return (
    <Dialog
      fit
      transition
      class="oa-codex-intro-dialog oa-startup-welcome-dialog"
    >
      <div class="oa-codex-intro-shell">
        <div class="oa-codex-intro-visual" data-variant="startup">
          <IconButton
            type="button"
            icon="close"
            variant="ghost"
            aria-label="Close"
            class="oa-codex-intro-close"
            onClick={() => dialog.close()}
          />
          <div class="oa-codex-intro-product-card">
            <div class="oa-codex-intro-product-bar">
              <div class="oa-codex-intro-product-brand">
                <Mark class="oa-codex-intro-visual-logo-mark" />
                <span>OpenAnalyst</span>
              </div>
            </div>
            <div class="oa-codex-intro-brief-card">
              <span class="oa-codex-intro-brief-eyebrow">First useful task</span>
              <strong class="oa-codex-intro-brief-title">Build an account brief from this workspace</strong>
              <p>Use files + 10X context before the first prompt.</p>
            </div>
            <div class="oa-codex-intro-flow">
              {WELCOME_SOURCES.map((source, index) => (
                <div class="oa-codex-intro-flow-step">
                  <span class="oa-codex-intro-flow-number" aria-hidden="true">{index + 1}</span>
                  <div class="oa-codex-intro-flow-copy">
                    <strong>{source.label}</strong>
                    <span>{source.detail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div class="oa-codex-intro-copy">
          <span class="oa-codex-intro-kicker">Welcome, {props.name}</span>
          <h2 class="oa-codex-intro-title">
            Your <span class="oa-codex-intro-title-highlight">OpenAnalyst</span> desk is set.
          </h2>
          <p>Work from your files, account context, and 10X workflows without setting up the same context twice.</p>
        </div>
        <div class="oa-codex-intro-actions">
          <Button
            type="button"
            variant="secondary"
            size="large"
            icon="square-arrow-top-right"
            class="oa-codex-intro-tenx-button"
            onClick={openTenX}
          >
            Go to 10X
          </Button>
          <Button type="button" variant="primary" size="large" icon="new-session" onClick={() => dialog.close()}>
            Explore OpenAnalyst
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
